/****   request.js   ****/
// 导入axios
import axios from 'axios'
// 使用element-ui Message做消息提醒
// import { Message,Loading } from 'element-ui';
import { message } from '../request/resetMessage'
import api from '@/api/api'
import Cookies from 'js-cookie'
import zhCN from "../assets/message/zh-CN.json";
import {CredentialsApiList,authorVendorApiList } from "../api/requestApi"
// axios.defaults.withCredentials = true;

//1. 创建新的axios实例，
const service = axios.create({
    // 公共接口--这里注意后面会讲
    baseURL: `${process.env.API_DOMAIN}`,
    // 超时时间 单位是ms，这里设置了15s的超时时间
    timeout: 15 * 1000,
    // withCredentials:false
})

var refreshPromise = null


// 添加请求拦截
service.interceptors.request.use(function (res) {
    //发送成功请求
    console.log(res.url)
    let Url = res.url
    if (CredentialsApiList.includes(Url)){
        res.withCredentials = true
        return res;
    }else if(authorVendorApiList.includes(Url)){
        res.headers["authorization"] = Cookies.get(`vendor_tokenid`+process.env.TITLE)
        return res
    }else{
        res.headers["authorization"] = Cookies.get(`custom_tokenid`+process.env.TITLE)
        return res
    }
}, function (error) {
    //发送错误请求的拦截 
    return Promise.reject(error);
});

// 添加响应拦截
service.interceptors.response.use(function (res) {
    // console.log('响应拦截res, ',res)
    //成功返回   
    return res;

}, function (error) {
    let err = error.response && error.response.status ? error.response : { status: 500 };
    // console.log('响应拦截error'+JSON.stringify(err))
    console.log(err)
    if(err.status == 401 || err.status == 403){
        message({
            message:'当前登录已过期，请重新登录',
            type: "warning"
        })
        let countdown = 2
        let timer = setInterval(() => {
            countdown -= 1;
            if (countdown <= 0) {
                clearInterval(timer);
                countdown = 2;
                if(Cookies.get(`custom_tokenid`+process.env.TITLE)){
                    Cookies.remove(`custom_tokenid`+process.env.TITLE)
                    Cookies.remove(`mobile`+process.env.TITLE)
                    window.location.replace("./login" );
                }else if(Cookies.get(`vendor_tokenid`+process.env.TITLE)){
                    Cookies.remove(`vendor_tokenid`+process.env.TITLE)
                    Cookies.remove(`mobile`+process.env.TITLE)
                    window.location.replace("./loginServer" );
                }else{
                    Cookies.remove(`custom_tokenid`+process.env.TITLE)
                    Cookies.remove(`vendor_tokenid`+process.env.TITLE)
                    Cookies.remove(`mobile`+process.env.TITLE)
                    window.location.replace("./" );
                }
                return;
            }
        }, 1000);
        
    }else{
        // return Promise.reject(err);
        return Promise.reject(error);
    }
})
//4.导入文件
export default service


// WEBPACK FOOTER //
// ./src/utils/request.js